import { useMutation } from 'react-query';

import { subscribeToAllNewsletters } from '@utils/backend-api/newsletters';

export default function useSubscribeToAllNewsletter() {
  const { mutate, mutateAsync, data, isLoading, isError, isSuccess } = useMutation(
    async () => await subscribeToAllNewsletters()
  );

  return { mutate, mutateAsync, data, isLoading, isError, isSuccess };
}
